import { GraphNode } from '../../graph/models/GraphNode.interface';
import { DrawGraphDataset } from '../../graph/models/DrawGraphDataset';
import { GraphDataset } from '../../graph/models/GraphDataset.interface';

export class GraphWorker {
    public worker: Worker;
    constructor() {
        this.init()
    }
    private init() {
        this.worker = new Worker(new URL('../../../worker.js', import.meta.url));
    }

    public async shortestPath(source: GraphNode, target: GraphNode, dataset: GraphDataset, satoshis: number): Promise<DrawGraphDataset> {
        return new Promise((resolve, reject) => {
            this.worker.onmessage = (event) => {
                const response = event.data.response;
                resolve(response);
            }
            this.worker.onerror = event => {
                console.error('WebWorker error', event);
                reject(event);
            } 
            const message = {
                method: 'calculateShortestPath',
                source: source,
                target: target,
                dataset: dataset,
                satoshis: satoshis
            };
            setTimeout(() => {
                this.worker.postMessage(message);
            }, 100);
            

        })

    }

    public terminate() {
        this.worker.terminate();
    }
}